import CityPageTemplate from "../city-template/CityPageTemplate";
import { freeportConfig } from "./data";

export default function FreeportPage() {
  return <CityPageTemplate config={freeportConfig} />;
}